import {VerificationCreateParams} from "../api/model/verification-create-params";
import {CaptchaBox} from "../captcha-box";
import {VERSION} from "../../../../version";
import {safeGet} from "./utils";
import {collectBrowserInformation} from "./browser-information";
import {generateFingerprints} from "./fingerprints/fingerprint-generator";
import {calculateIntegrityHash} from "./integrity-hasher";
import {detectFrontendFramework} from "./detectors";
import {resolveTimezone} from "./environment";

export class InformationCollector {

  constructor(private readonly box: CaptchaBox) {}

  public async collectInformation(): Promise<VerificationCreateParams> {

    const minimalDataMode = this.box.config.minimalDataMode;
    const browserInformation = collectBrowserInformation(minimalDataMode);
    const fingerprints = await generateFingerprints();
    const integrityHash = await calculateIntegrityHash(browserInformation);

    return {
      siteKey: this.box.config.siteKey,
      widget: {
        boxCreationTimestamp: this.box.boxCreationTimestamp,
        startSolvingTimestamp: new Date(),
        timezone: resolveTimezone(),
        minimalDataMode,
        bypassToken: this.box.config.bypassToken,
        settings: {
          language: this.box.config.language,
          currentLanguage: this.box.config.translation.language,
          theme: this.box.config.theme,
          currentTheme: this.box.config.currentTheme,
          autostartDisabled: this.box.config.autostartDisabled,
          whiteLabel: this.box.config.whiteLabel,
          privacyUrlSet: Boolean(this.box.config.privacyUrl),
          invisible: this.box.config.invisible,
          fullWidth: this.box.config.fullWidth,
        },
      },
      metadata: {
        framework: safeGet(() => detectFrontendFramework(this.box.config.framework)),
        libraryVersion: VERSION,
      },
      browserInformation,
      fingerprints,
      honeypotFields: this.box.getHoneypotSnapshot(),
      userEvents: this.box.eventTracker.getEventsAndResetArray(),
      integrityHash,
    };
  }
}
